import React, { useState } from "react";
import { useTheme } from "../../context/ThemeContext";

const QuestionOptionModal = ({ isOpen, onClose, onSubmit }) => {
    const [numberOfQuestions, setNumberOfQuestions] = useState(10);
    const [difficulty, setDifficulty] = useState("medium");
    const { themeStyles } = useTheme();


    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div
                className="bg-white m-10 rounded-lg p-6 w-96 shadow-lg border md:ml-[300px]"
                style={{
                    backgroundColor: themeStyles.cardBackground,
                    color: themeStyles.text,
                }}
            >

                {/* Number of Questions Input */}
                <div className="mb-4">
                    <label htmlFor="numberOfQuestions" style={{
                        display: 'block',
                        fontWeight: 'bold',
                        marginBottom: 5,
                        fontSize: 14
                    }}>
                        Number of Questions
                    </label>
                    <input
                        type="number"
                        id="numberOfQuestions"
                        value={numberOfQuestions}
                        onChange={(e) => setNumberOfQuestions(e.target.value)}
                        className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2"
                        style={{
                            backgroundColor: themeStyles.cardContentBackground,
                            color: themeStyles.text,
                            borderColor: themeStyles.text,
                        }}
                    />
                </div>

                {/* Difficulty Dropdown */}
                <div className="mb-4">
                    <label htmlFor="difficulty" style={{
                        display: 'block',
                        fontWeight: 'bold',
                        marginBottom: 5,
                        fontSize: 14
                    }}>
                        Difficulty
                    </label>
                    <select
                        id="difficulty"
                        value={difficulty}
                        onChange={(e) => setDifficulty(e.target.value)}
                        className="w-full px-2 py-2 border rounded-md focus:outline-none focus:ring-2"
                        style={{
                            backgroundColor: themeStyles.cardContentBackground,
                            color: themeStyles.text,
                            borderColor: themeStyles.text,
                        }}
                    >
                        <option value="easy">Easy</option>
                        <option value="medium">Medium</option>
                        <option value="hard">Hard</option>
                    </select>
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end">
                    <button
                        className="px-4 py-2 mr-2 text-white bg-red-500 rounded-md hover:bg-red-600"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="px-4 py-2 text-white bg-custom-blue rounded-md hover:bg-blue-900"
                        onClick={() => onSubmit(numberOfQuestions, difficulty)}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
};

export default QuestionOptionModal;
